<template>
     <header id="header">
        <div class="headerTop">
          <div class="container">
            <div class="logo">
              <a href="#/">
                <img
                  src="../assets/logo.svg"
                  alt="Inside Burgundy"
                  class
                >
              </a>
            </div>
            <div class="headRight">
              <ul>
                <!--<li><a href="javascript:void(0)" data-remodal-target="loginForm" class="loginPop">Log in / Register</a></li>-->
                <template v-if="$store.state.isLogin">
                    <li>
                        <a href="#/Myinformation">{{$store.state.userdata.nickname}}</a>
                    </li>
                    <li>
                        <a  style="cursor:pointer" @click="quitLogin">退出登录</a>
                    </li>
                </template>
                <template v-else>
                    <li>
                    <a href="#/Login">登录</a>
                    </li>
                    <li class="registermresLink">
                    <a href="#/Register">注册</a>
                    </li>
                </template>

                <li>
                  <a href="#/Faqs">常见问题解答</a>
                </li>
              </ul>
              <div class="searchBox">
                <form
                  id="searchHeaderForm"
                >
                  <input
                    type="text"
                    id="searchHeader"
                    name="search"
                    placeholder="快速查询"
                  >
                  <input type="submit" value="查询" @click="hreftwo">
                </form>
              </div>
              <div class="menuBtn">
                <span>Menu</span>
                <div class="hamburger hamburger--squeeze">
                  <div class="hamburger-box">
                    <div class="hamburger-inner"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nav class="main-nav">
          <div class="container">
            <ul id="menu-top-menu" >
              <li
                id="menu-item-1"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-33"
              >
                <a href="#/JASPER">
                  关于Inside Burgundy
                </a>
              </li>
              <li id="menu-item-2" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-33">
                  <a href="#/Burgundy">
                  关于勃艮第
                </a>
              </li>
              <li
                id="menu-item-3"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-31"
              >
                <a href="#/theactivity">
                  最新活动
                </a>
              </li>
              <li
                id="menu-item-4"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-29"
              >
                <a href="#/Appraisal">品鉴报告</a>
              </li>
              <li
                id="menu-item-5"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-30"
              >
                <a href="#/report">最新资讯</a>
              </li>
              <li
                v-if="!$store.state.isLogin"
                id="menu-item-6"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-975"
              >
                <a href="#/Subscribe">订阅</a>
              </li>
              <li
                v-else
                id="menu-item-7"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-975"
              >
                <a href="#/Myinformation">个人中心</a>
              </li>
            </ul>
          </div>
        </nav>
        <nav class="mobile-nav easeAll">
          <ul id="menu-mobile-menu" class>
            <li
              id="menu-item-1"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-981"
            >
              <a href="#/JASPER">
                  关于Inside Burgundy
                </a>
            </li>
            <li
              id="menu-item-2"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-514"
            >
               <a href="#/Burgundy">
                  关于勃艮第
                </a>
            </li>
            <li
              id="menu-item-3"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-515"
            >
              <a href="#/theactivity">
                  最新活动
                </a>
            </li>
            <li
              id="menu-item-4"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-516"
            >
              <a href="#/Appraisal">品鉴报告</a>
            </li>
            <li
              id="menu-item-5"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-517"
            >
              <a href="#/report">最新资讯</a>
            </li>
            <li
             v-if="!$store.state.isLogin"
              id="menu-item-6"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-517"
            >
             <a href="#/Subscribe">订阅</a>
            </li>
            <template  v-if="$store.state.isLogin">

            <li>
                <a href="#/Myinformation">{{$store.state.username}}</a>
            </li>
            <li>
                <a  style="cursor:pointer" @click="quitLogin">退出登录</a>
            </li>
            </template>
            <template v-else>
              <li>
                <a href="#/Login">登录</a>
              </li>
              <li class="registermresLink">
                <a href="#/Register">注册</a>
              </li>
            </template>
          </ul>
        </nav>
        <div class="menuoverlay" style="display: none;"></div>
      </header>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    mounted() {
        let _this = this;
        $('#menu-top-menu').find('li').click(function(){
            _this.menuActive($(this))
        })

        // setTimeout(()=>{
        //     _this.$store.commit('setLogin')
        // },2000)

        $('.menuBtn').click(function(){
          if($('.hamburger').hasClass('is-active')){
            $('.hamburger').removeClass('is-active')
            $('.mobile-nav').css('right','-396px')
            $('.menuoverlay').hide()
          }else{
            $('.hamburger').addClass('is-active')
            $('.mobile-nav').css('right','0')
            $('.menuoverlay').show()
          }
        })

        $('.menuoverlay').click(function(){
          $('.hamburger').removeClass('is-active')
            $('.mobile-nav').css('right','-396px')
            $('.menuoverlay').hide()
        })
    },
    methods: {
      quitLogin(){
        if(confirm('是否退出当前帐户？')){
          this.$store.commit('quitLogin')
          this.$router.push('/home')          
        }
      },
        hreftwo(e) {
            e.preventDefault();
            let keyword = $('#searchHeader').val()
            if(keyword){
                window.SearchQuery = {keyword};
              this.$router.push({ path: "./insideburgundy?keyword="+keyword });
            }else{
                alert('请输入关键字进行查询！')
            }
        },
        isLogin(t){
            if(t)
                $('#menu-item-6').remove()
            else
                $('#menu-item-7').remove()
        },
        menuActive(dom){
        $('#menu-top-menu').find('li').removeClass('current-menu-item current_page_item')
        if(dom)
        dom.addClass('current-menu-item current_page_item')
        },
        menuSwitch(name){
            let n = 0;
            switch(name){
                case 'JASPER':n=1;break
                case 'Burgundy':n = 2;break;
                case 'Theactivity':n = 3;break;
                case 'Report':n = 5;break;
                case 'Appraisal':n = 4;break;
                case 'Subscribe':n = 6;break;
                case 'Myinformation':n = 7;break;
            }
        this.menuActive($('#menu-item-'+n))
        }
    },
    watch: {
        $route(newValue){
            this.menuSwitch(newValue.name)
        },
        '$store.state.isLogin'(){
            let _this = this;
             $('#menu-top-menu').find('li').click(function(){
            _this.menuActive($(this))
            })
        }
    },
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/template/header.vue